import { Headphones } from "lucide-react";
import "./Spotify.css"

const Spotify = ({ label, url, size = 42 }) => {
  const handleClick = () => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  return (
    <div className="spotify-component">
      <span>{label}</span>
      <Headphones
        size={size}
        className="listen-icon"
        onClick={handleClick}
      />
    </div>
  );
};

export default Spotify;